/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface MoveSessionEventDto
 */
export interface MoveSessionEventDto {

    /**
     * New start of the session, ISO 8601 with offset (e.g. 2026-08-14T10:00:00.000Z). Must be in the future and inside the therapy's own date window.
     *
     * @type {string}
     * @memberof MoveSessionEventDto
     * @example 2026-08-14T10:00:00.000Z
     */
    start: string;
}
